<script setup lang="ts">
const { dialogOpen, message } = useAppStatus();
const { t } = useI18n();

const safeMessage = computed(() => sanitizeHtml(message.value));
const buttons = computed(() => [
  {
    label: t("status.acknowledge"),
    onClick: () => {
      dialogOpen.value = false;
    },
  },
]);
</script>

<template>
  <AppDialog v-model:open="dialogOpen" :buttons="buttons" :title="$t('status.dialog.title')">
    <template #description>
      <AppSafeHtml class="cms-content" :content="safeMessage" />
    </template>
  </AppDialog>
</template>
